<template>
  <v-container fluid class="fill-height py-0">
    <MainTwoSides>
      <template v-slot:ladoIzquierdo>
        <ListaPublicaciones />
      </template>
      <template v-slot:ladoDerecho>
        <DetallePublicaciones />
      </template>
    </MainTwoSides>
  </v-container>
</template>

<script>
export default {
  components: {
    MainTwoSides: () => import('@/components/user/common/MainTwoSides.vue'),
    ListaPublicaciones: () =>
      import('@/components/user/publicaciones/ListaPublicaciones.vue'),
    DetallePublicaciones: () =>
      import('@/components/user/publicaciones/DetallePublicaciones.vue')
  }
}
</script>

<style>
</style>